export default __webpack_public_path__ + "static/media/Cover1.96626c72.png";